import script from "./countdown.vue?vue&type=script&setup=true&lang=js"
export * from "./countdown.vue?vue&type=script&setup=true&lang=js"

import "./countdown.vue?vue&type=style&index=0&id=1ec11061&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.4.27_vue@3.2.36_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec11061"]])

export default __exports__